"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeros = void 0;
function zeros(length) {
    return new Array(length).fill(0);
}
exports.zeros = zeros;
//# sourceMappingURL=zeros.js.map